import __request__ from "routing/request";
export function listCollectors() {
  return __request__("GET", "/sidecar/collectors", null, {}, {
    "Accept": ["application/json"]
  });
}
export function createCollector(JSONbody) {
  return __request__("POST", "/sidecar/collectors", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function listSummary(sort = "name", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/sidecar/collectors/summary", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function validateCollector(collector) {
  return __request__("POST", "/sidecar/collectors/validate", collector, {}, {
    "Accept": ["application/json"]
  });
}
export function getCollector(id) {
  return __request__("GET", `/sidecar/collectors/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function updateCollector(id, JSONbody) {
  return __request__("PUT", `/sidecar/collectors/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteCollector(id) {
  return __request__("DELETE", `/sidecar/collectors/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function copyCollector(id, name) {
  return __request__("POST", `/sidecar/collectors/${id}/${name}`, null, {}, {
    "Accept": ["application/json"]
  });
}
